// @vendors
import React from "react";

export default function OfferIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
  <path fillRule="evenodd" d="M32.567 16.718a5.15 5.15 0 1 1-7.285-7.284 5.15 5.15 0 0 1 7.285 7.284zM39.466 0H21.735c-1.4 0-1.655.61-2.99 2.006L5.548 15.16 26.85 36.453l13.233-13.186C41.204 22.147 42 21.59 42 20.194V2.524A2.53 2.53 0 0 0 39.466 0zM26.963 11.115a2.773 2.773 0 1 0 3.922 3.922 2.773 2.773 0 0 0-3.922-3.922zM1.611 19.029a5.485 5.485 0 0 0 0 7.766l13.611 13.597a5.507 5.507 0 0 0 7.779 0l2.357-2.355L4.001 16.642l-2.39 2.387z"/>
</svg>
  );
}